import React from "react";
import { MapPin } from "lucide-react";
import { Input } from "@/components/ui/input";
import { TAMIL_NADU_DISTRICTS } from "@/constants/locations";

export default function LocationSelector({ location, onChange, required = false }) {
  const handleChange = (field, value) => {
    onChange({
      ...location,
      [field]: value,
      state: "Tamil Nadu" // Always Tamil Nadu
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2 mb-4">
        <MapPin className="w-5 h-5 text-primary" />
        <h3 className="font-semibold text-lg">Location Details</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* District */}
        <div>
          <label className="block text-sm font-medium mb-2">
            District {required && <span className="text-red-500">*</span>}
          </label>
          <select
            value={location?.district || ""}
            onChange={(e) => handleChange("district", e.target.value)}
            required={required}
            className="w-full px-4 py-2 rounded-lg border border-input bg-background"
            data-testid="location-district-select"
          >
            <option value="">Select District</option>
            {TAMIL_NADU_DISTRICTS.map((district) => (
              <option key={district} value={district}>
                {district}
              </option>
            ))}
          </select>
        </div>

        {/* City */}
        <div>
          <label className="block text-sm font-medium mb-2">
            City/Town {required && <span className="text-red-500">*</span>}
          </label>
          <Input
            type="text"
            value={location?.city || ""}
            onChange={(e) => handleChange("city", e.target.value)}
            placeholder="Enter city or town"
            required={required}
            data-testid="location-city-input"
          />
        </div>

        {/* Pincode */}
        <div>
          <label className="block text-sm font-medium mb-2">
            Pincode {required && <span className="text-red-500">*</span>}
          </label>
          <Input
            type="text"
            value={location?.pincode || ""}
            onChange={(e) => handleChange("pincode", e.target.value)}
            placeholder="6-digit pincode"
            maxLength={6}
            required={required}
            data-testid="location-pincode-input"
          />
        </div>

        {/* State (Read-only) */}
        <div>
          <label className="block text-sm font-medium mb-2">State</label>
          <Input
            type="text"
            value="Tamil Nadu"
            disabled
            className="bg-muted"
            data-testid="location-state-input"
          />
        </div>
      </div>
    </div>
  );
}
